var React = require('react');

function IcFacebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_837","data-name":"Group 837","transform":"translate(0 0)"},[React.createElement("circle",{"id":"Ellipse_90","data-name":"Ellipse 90","cx":"16","cy":"16","r":"16","transform":"translate(0 0)","fill":"#5388ff","key":0}),React.createElement("path",{"id":"Path_751","data-name":"Path 751","d":"M386.385,303.051h2.6v-6.47H390.9l.383-2.9h-2.3v-1.316a1.251,1.251,0,0,1,1.269-1.274h1.121v-2.406l-2.006-.106c-1.917-.142-2.979,1.663-2.979,3.822v1.28H384.2v2.9h2.183Z","transform":"translate(-372.349 -280.474)","fill":"#fff","fillRule":"evenodd","key":1})]));
}

IcFacebook.defaultProps = {"width":"30","height":"30","viewBox":"0 0 32 32"};

module.exports = IcFacebook;

IcFacebook.default = IcFacebook;
